import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import MeetingSheetResultLayer from "../../../components/Admin/MeetingSheetResultLayer";

const MeetingSheetResult = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <MeetingSheetResultLayer />
      </MasterLayout>
    </>
  );
};

export default MeetingSheetResult
